import {
  faExclamationCircle,
  faShieldAlt,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { hasFeature } from '@precert/has-feature';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormGroup } from 'reactstrap';

import { PageLoader } from '../../../_components';
import { useConfig } from '../../../_components/config';
import InputField from '../../../_components/input-field';
import SelectField from '../../../_components/select-components/select-field';

import { RequestSent } from './request-sent';
import { SessionAvailable } from './session-available';
import styles from './styles.module.scss';
import Submit from './submit';

export enum RequestedByType {
  Provider = 'PRO',
}

type FormValues = {
  email: string;
  formType: RequestedByType.Provider;
};

interface RequestFormProps {
  error?: Error;
  handleSubmit: () => void;
  loading: boolean;
  onStart: () => void;
  onStartOver: () => void;
  submittedStatus: string | null;
  values: FormValues;
}

export default function RequestForm({
  error,
  loading,
  onStart,
  onStartOver,
  submittedStatus,
  handleSubmit,
}: RequestFormProps) {
  const submitted = ['sent', 'unneeded'].includes(submittedStatus || '');

  const [ResultNotice, nextHandler] =
    submitted && submittedStatus === 'sent'
      ? [RequestSent, onStartOver]
      : [SessionAvailable, onStart];

  const { getValues } = useFormContext();
  const { features } = useConfig();

  return submitted && !error ? (
    <ResultNotice email={getValues('email')} onNext={nextHandler} />
  ) : (
    <>
      {loading && <PageLoader />}
      <h1 tabIndex={0} className={styles.header} id="main-content">
        Precertification Portal
      </h1>
      <div className={'alert alert-info'}>
        <div className="d-flex align-items-center">
          <div>
            <FontAwesomeIcon icon={faShieldAlt} size="3x" />
          </div>

          <div className={`${styles.alert} ms-2`}>
            Please submit the information below in order to be sent an email
            with your secured link.
          </div>
        </div>
      </div>

      {error ? (
        <div className={'alert alert-danger'}>
          <div className="d-flex align-items-center">
            <div>
              <FontAwesomeIcon icon={faExclamationCircle} size="3x" />
            </div>
            <div className={`${styles.alert} ms-2`}>
              Unable to process your request at this time. Please try again.
            </div>
          </div>
        </div>
      ) : null}
      <div className={styles.legend} tabIndex={0}>
        Indicates required field
      </div>
      <form>
        <FormGroup>
          <InputField required label="Email" name="email" />
        </FormGroup>
        {!hasFeature('update-precert', features) && (
          <FormGroup>
            <SelectField
              required
              label="Reporting as (select one)"
              name="formType"
              options={[{ label: 'Provider', value: RequestedByType.Provider }]}
            />
          </FormGroup>
        )}
        <Submit handleSubmit={handleSubmit} />
      </form>
    </>
  );
}
